<body>
  <div class="grid-overlay">
    <app-page-header>
      <button class="header-action-btn" (click)="goBack()">{{ 'customerPlanUpdate.buttons.back' | translate }}</button>
    </app-page-header>
    <div class="setting-data">
      <div class="second-headboard">
        <h1>{{ 'customerPlanUpdate.title' | translate }}</h1>
        <!-- <img src="../../assets/icons/1234.png" alt="logo de Billcentrix"> -->

      </div>
      <div class="general-data">
        <h1>{{ 'customerPlanUpdate.generalData' | translate }}</h1>
        <form [formGroup]="form" >
          <div class="grid">
            <div class="left">
              <div class="items">

                <label for="name">{{ 'customerPlanUpdate.fields.service' | translate }}*</label>
                <input [formControl]="form.controls['service']"
                  type="text" readonly   value="{{ chp?.plan?.service?.name_service || '-' }}">


                </div>

                <div class="items">
                  <label for="code">{{ 'customerPlanUpdate.fields.name' | translate }}*</label>
                  <input type="text" readonly   value="{{ customer?.name_customer || '-' }} {{customer?.lastName_customer || '-' }}">
                </div>

                <div class="items">
                  <label for="email">{{ 'customerPlanUpdate.fields.contractNumber' | translate }}*</label>
                  <input [formControl]="form.controls['contractNumber_Plan']"
                    type="text">

                  </div>

                  <div class="items">
                    <label for="createdAt">{{ 'customerPlanUpdate.fields.creationDate' | translate }}*</label>
                    <input type="text" readonly value="{{ formattedCreatedAt || '-' }}">
                  </div>

                  <div class="items">
                    <label for="email">{{ 'customerPlanUpdate.fields.enrollmentDate' | translate }}*</label>
                    <input type="text" readonly  [formControl]="form.controls['startdate_customerPlan']">
                  </div>

                  <div class="items">
                    <label for="tdc">{{ 'customerPlanUpdate.fields.creditCard' | translate }}*</label>
                    <div class="select-wrapper">
                      <select id="tdc" [formControl]="form.controls['tdc']" >
                        <option disabled="" selected="" value="">{{ 'customerPlanUpdate.fields.creditCardPlaceholder' | translate }}</option>
                        @for (tarjeta of tarjetas; track tarjeta) {
                          <option  [value]="tarjeta.id">{{tarjeta.maskCreditCard}} - {{tarjeta.nameHolderCreditCard}} - {{tarjeta.expiration_month}}/{{tarjeta.expiration_year}}</option>
                        }
                      </select>
                      <i class="arrow"></i>
                      @if (form.controls['tdc'].hasError('required') && form.controls['tdc'].touched) {
                        <small
                          class="form-error-msg"> {{ 'customerPlanUpdate.fields.creditCardError' | translate }}
                        </small>
                      }
                    </div>
                  </div>



                </div>


                <div class="right">

                  <div class="items">
                    <label for="address">{{ 'customerPlanUpdate.fields.plan' | translate }}*</label>
                    <div class="select-wrapper"
                      [matTooltip]="currentPlanType === PlanType.LINK_DE_PAGO ? ('customerPlanUpdate.linkDePagoTooltip' | translate) : ''"
                      matTooltipPosition="above">
                      <span [matTooltip]="isOnDemandPlan ? ('customerPlan.onDemandLocked' | translate) : ''">
                        <select id="plan" [formControl]="form.controls['plan']"
                          (change)="onPlanChange($event.target.value)">
                          <option disabled="" selected="" value="">{{ 'customerPlanUpdate.fields.planPlaceholder' | translate }}</option>
                          @for (plan of servicePlans; track plan) {
                            <option  [value]="plan.id">{{plan.name_plan}} </option>
                          }
                        </select>
                      </span>
                      <i class="arrow"></i>
                      @if (form.controls['plan'].hasError('required') && form.controls['plan'].touched) {
                        <small
                          class="form-error-msg"> {{ 'customerPlanUpdate.fields.planError' | translate }}
                        </small>
                      }
                    </div>
                    @if (currentPlanType === PlanType.LINK_DE_PAGO) {
                      <small
                        class="form-info-msg">
                        {{ 'customerPlanUpdate.linkDePagoMessage' | translate }}
                      </small>
                    }

                    <!-- BILL-2569: campos custom para planes VARIABLE -->
                    @if (showVariableFields) {
                      <div class="items">
                        <label for="customAmount">{{ 'customerPlanUpdate.fields.amountWithTax' | translate }}*</label>
                        <input id="customAmount"
                          type="number"
                          min="0"
                          step="0.01"
                          placeholder="{{ 'customerPlanUpdate.fields.amountWithTax' | translate }}"
                          [formControl]="form.controls['customAmount']">
                          @if (form.controls['customAmount'].invalid && form.controls['customAmount'].touched) {
                            <small
                            class="form-error-msg">{{ 'customerPlanUpdate.fields.amountWithTaxError' | translate }}</small>
                          }
                        </div>
                        <div class="items">
                          <label for="customTaxRate">{{ 'customerPlanUpdate.fields.taxPercentage' | translate }}*</label>
                          <input id="customTaxRate"
                            type="number"
                            min="0"
                            step="0.01"
                            placeholder="{{ 'customerPlanUpdate.fields.taxPercentagePlaceholder' | translate }}"
                            [formControl]="form.controls['customTaxRate']">
                            @if (form.controls['customTaxRate'].invalid && form.controls['customTaxRate'].touched) {
                              <small
                              class="form-error-msg">{{ 'customerPlanUpdate.fields.taxPercentageError' | translate }}</small>
                            }
                          </div>
                        }

                        <!-- <input type="text" readonly   value="{{ chp?.plan?.name_plan || '-' }}"> -->
                      </div>

                      <div class="items">
                        <label for="status_customerPlan">{{ 'customerPlanUpdate.fields.currentStatus' | translate }}: {{currentStatusDescription}}</label>

                        <!-- Campo editable: dropdown solo con opciones de transición -->
                        @if (isStatusEditable) {
                          <div class="select-wrapper">
                            <span [matTooltip]="isOnDemandPlan ? ('customerPlan.onDemandLocked' | translate) : ''">
                              <select id="status_customerPlan" [formControl]="form.controls['status_customerPlan']">
                                <option [value]="initialStatus" disabled style="display: none;">{{ 'customerPlanUpdate.fields.statusPlaceholder' | translate }}</option>
                                @for (status of availableStatuses; track status) {
                                  <option [value]="status.value">{{status | catalogTranslate:'subscription_status' | async}} </option>
                                }
                              </select>
                            </span>
                            <i class="arrow"></i>
                            @if (form.controls['status_customerPlan'].hasError('required') && form.controls['status_customerPlan'].touched) {
                              <small
                                class="form-error-msg"> {{ 'customerPlanUpdate.fields.statusError' | translate }}
                              </small>
                            }
                          </div>
                        }

                        <!-- Campo no editable: solo mostrar descripción -->
                        @if (!isStatusEditable) {
                          <div>
                            <input type="text" readonly [value]="currentStatusDescription" class="readonly-status">
                          </div>
                        }
                      </div>

                      <div class="items">
                        <label for="address">{{ 'customerPlanUpdate.fields.renewalCode' | translate }}*</label>
                        <input [formControl]="form.controls['idPlanEnrollmentrenewalPartner']"
                          type="text" readonly  >

                        </div>


                        <div class="items">
                          <label for="address">{{ 'customerPlanUpdate.fields.endDate' | translate }}*</label>
                          <div class="culminacion_date">
                            <mat-form-field class="full-width">
                              <input
                                matInput
                                [matDatepicker]="pickerEndDate"
                                placeholder="{{ 'customerPlanUpdate.fields.endDate' | translate }}*"
                                formControlName="endDate_customerPlan"
                                name="endDate">
                                <mat-datepicker-toggle matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
                                <mat-datepicker #pickerEndDate></mat-datepicker>
                              </mat-form-field>
                            </div>
                          </div>

                          <!-- Aquí combinamos el input y el botón en un mismo contenedor -->
                          @if (initialStatus != 2) {
                            <div class="items">
                              <label for="email">{{ 'customerPlanUpdate.fields.nextBillingDate' | translate }}*</label>
                              <div class="next-billing">
                                <!--                                <input type="text"-->
                                <!--                                       readonly-->
                                <!--                                       value="{{ chp?.next_bill_date }}">-->
                                <mat-form-field class="full-width">
                                  <!--                                            <mat-label>Hasta</mat-label>-->
                                  <input
                                    matInput
                                    [matDatepicker]="pickerHasta"
                                    placeholder="{{ 'customerPlanUpdate.fields.nextBillingDate' | translate }}*"
                                    formControlName="next_bill_date"
                                    name="until">
                                    <mat-datepicker-toggle matSuffix [for]="pickerHasta"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerHasta></mat-datepicker>
                                  </mat-form-field>
                                  <div class="billing-actions">
                                    <button class="skip-btn"
                                      [matTooltip]="'customerPlanUpdate.fields.skipBillingTooltip' | translate"
                                      (click)="openSkipBillingDialog()">
                                      {{ 'customerPlanUpdate.fields.skipBilling' | translate }}
                                    </button>
                                    @if (reactivableInvoice) {
                                      <button type="button" class="reactivate-btn"
                                        [disabled]="isReactivating"
                                        (click)="openReactivateDialog()">
                                        <span aria-hidden="true">↻</span> {{ 'customerPlanUpdate.reactivate.button' | translate }}
                                      </button>
                                    }
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                        @if (initialStatus != 2) {
                          @if (reactivableInvoice) {
                            <div class="limit-banner">
                              <strong><span aria-hidden="true">⚠</span> {{ 'customerPlanUpdate.reactivate.limitBanner.title' | translate }}</strong>
                              {{ 'customerPlanUpdate.reactivate.limitBanner.message' | translate:{invoiceNumber: reactivableInvoice.invoiceNumber, invoiceDate: reactivableInvoice.invoiceDate} }}
                            </div>
                          }
                          @if (reactivationDone) {
                            <div class="success-banner">
                              <strong><span aria-hidden="true">✓</span> {{ 'customerPlanUpdate.reactivate.success.title' | translate }}</strong>
                              {{ 'customerPlanUpdate.reactivate.success.message' | translate:{invoiceNumber: reactivationDone.invoiceNumber} }}
                            </div>
                          }
                        }
                      </form>
                    </div>
                  </div>


                  <div class="options-buttons">
                    <button class="back-btn" (click)="goBack()" >{{ 'customerPlanUpdate.buttons.cancel' | translate }}</button>
                    <!-- [disabled]="!showPaymentButton" -->
                    <button  [disabled]="form.invalid" class="continue-btn" (click)="update()" >{{ 'customerPlanUpdate.buttons.save' | translate }}</button>
                  </div>
                </div>
              </body>
              <ng-template #changePlanConfirmDialog let-dialogRef="dialogRef">
                <div class="dialog-content">
                  <h1>{{ 'customerPlanUpdate.changePlanDialog.title' | translate }}</h1>
                  <p>
                    {{ 'customerPlanUpdate.changePlanDialog.message' | translate }}<br>
                    {{ 'customerPlanUpdate.changePlanDialog.subMessage' | translate }}
                  </p>
                  <div class="dialog-buttons">
                    <button (click)="dialogRef.close(false)">{{ 'customerPlanUpdate.changePlanDialog.cancel' | translate }}</button>
                    <button (click)="dialogRef.close(true)" class="confirmar">{{ 'customerPlanUpdate.changePlanDialog.confirm' | translate }}</button>
                  </div>
                </div>
              </ng-template>
              <ng-template #blockingInvoicesDialog let-dialogRef="dialogRef">
                <div class="dialog-content">
                  <h1>{{ 'customerPlanUpdate.blockingInvoices.title' | translate }}</h1>
                  <p>{{ 'customerPlanUpdate.blockingInvoices.message' | translate }}</p>
                  <ul class="blocking-invoices-list">
                    @for (inv of blockingInvoices; track inv) {
                      <li>
                        {{ 'customerPlanUpdate.blockingInvoices.invoiceLabel' | translate }} #{{inv.id}}
                        — {{ 'customerPlanUpdate.blockingInvoices.statusLabel' | translate }} {{inv.status}}
                        @if (inv.total) {
                          <span> — Total: {{inv.total}}</span>
                        }
                      </li>
                    }
                  </ul>
                  <div class="dialog-buttons">
                    <button (click)="dialogRef.close(true)" class="confirmar">{{ 'customerPlanUpdate.blockingInvoices.close' | translate }}</button>
                  </div>
                </div>
              </ng-template>
              <ng-template #reactivateBillingDialog let-dialogRef="dialogRef">
                <div class="reactivate-dialog">
                  <div class="reactivate-icon" aria-hidden="true">↻</div>
                  <h3 id="reactivate-dialog-title">{{ 'customerPlanUpdate.reactivate.dialog.title' | translate }}</h3>
                  <p>{{ 'customerPlanUpdate.reactivate.dialog.message' | translate }}</p>
                  @if (reactivableInvoice) {
                    <div class="reactivate-kv">
                      <span>{{ 'customerPlanUpdate.reactivate.dialog.invoice' | translate }}</span><strong>#{{ reactivableInvoice.invoiceNumber }}</strong>
                      <span>{{ 'customerPlanUpdate.reactivate.dialog.invoiceDate' | translate }}</span><strong>{{ reactivableInvoice.invoiceDate }}</strong>
                      <span>{{ 'customerPlanUpdate.reactivate.dialog.nextBillingDate' | translate }}</span><strong>{{ reactivableInvoice.nextBillDate }}</strong>
                      <span>{{ 'customerPlanUpdate.reactivate.dialog.amount' | translate }}</span><strong>{{ reactivableInvoice.amount | number:'1.2-2' }}</strong>
                    </div>
                  }
                  <div class="reactivate-actions">
                    <button type="button" class="reactivate-cancel" (click)="dialogRef.close(false)">{{ 'customerPlanUpdate.reactivate.dialog.cancel' | translate }}</button>
                    <button type="button" class="reactivate-confirm" (click)="dialogRef.close(true)">{{ 'customerPlanUpdate.reactivate.dialog.confirm' | translate }}</button>
                  </div>
                </div>
              </ng-template>
              <ng-template #skipBillingDialog let-dialogRef="dialogRef">

                <div class="dialog-content">
                  <h1>{{ 'customerPlanUpdate.skipDialog.title' | translate }}</h1>
                  <p>
                    {{ 'customerPlanUpdate.skipDialog.message' | translate }}<br>
                    {{ 'customerPlanUpdate.skipDialog.subMessage' | translate }}
                  </p>
                  <div class="dialog-buttons">
                    <button (click)="dialogRef.close(false)">{{ 'customerPlanUpdate.skipDialog.cancel' | translate }}</button>
                    <button (click)="dialogRef.close(true)" class="confirmar">{{ 'customerPlanUpdate.skipDialog.confirm' | translate }}</button>
                  </div>
                </div>
              </ng-template>
